export enum Categories {
  ACCESORIES = 'accessories',
  BATH_BODY = 'bath-body',
  FRAGNANCE = 'fragrance',
  HAIR = 'hair',
  MAKEUP = 'makeup',
  MEN = 'men',
  SKINCARE = 'skincare',
  WELLNES = 'wellness',
  ESSENTIAL_OILS = 'essential-oils',
  KIDS_BABY = 'kids-baby',
}
